import React, { SyntheticEvent, useState } from 'react'
import clsx from 'clsx'
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import PatientFormModificationsHistoryRow from './PatientFormModificationsHistoryRow'
import { PatientFormModificationsHistoryRowsProps } from './_props'
import useStyles from '../_styles/PatientFormModificationsHistoryStyles'
import { generateRandomGuiID } from '../../../../utils/commonUtils'

const PatientFormModificationsHistoryRows: React.FC<PatientFormModificationsHistoryRowsProps> = ({
    label,
    historyRows,
    displayMostRecentAction = false,
}) => {
    const classes = useStyles()

    const mostRecentHistory = historyRows[0]

    const [expandedAction, setExpandedAction] = useState<string>('')
    const [isMostRecentActionExpanded, setMostIsRecentActionExpanded] = useState<boolean>(false)

    const handleExpandActionDetails = (actionId: string) => (e: SyntheticEvent, newExpanded: boolean) => {
        setExpandedAction(newExpanded ? actionId : '')
    }

    const handleExpandMostRecentActionDetails = () => () => {
        setMostIsRecentActionExpanded(!isMostRecentActionExpanded)
    }

    return (
        <>
            {mostRecentHistory && displayMostRecentAction && (
                <Box
                    className={clsx(
                        classes.PatientFormModificationsHistoryLast,
                        classes.PatientFormModificationsHistoryInfoContainer,
                    )}
                >
                    <Typography className={classes.PatientFormModificationsHistoryItem}>Dernière action :</Typography>
                    <PatientFormModificationsHistoryRow
                        row={mostRecentHistory}
                        handleExpandPanel={handleExpandMostRecentActionDetails}
                        expandedPanel={isMostRecentActionExpanded}
                        mostRecent
                    />
                </Box>
            )}
            <Accordion className={classes.PatientFormModificationsHistoryAccordion}>
                <AccordionSummary
                    className={classes.PatientFormModificationsHistoryAccordionSummary}
                    expandIcon={<ArrowDropDownRoundedIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography>
                        {label} ({historyRows.length})
                    </Typography>
                </AccordionSummary>
                <AccordionDetails
                    className={clsx(
                        classes.PatientFormModificationsHistoryInfoContainer,
                        classes.PatientFormModificationsHistoryAccordionDetails,
                    )}
                >
                    {historyRows.map((historyRow) =>
                        historyRow ? (
                            <PatientFormModificationsHistoryRow
                                key={generateRandomGuiID()}
                                row={historyRow}
                                handleExpandPanel={handleExpandActionDetails}
                                expandedPanel={expandedAction}
                            />
                        ) : null,
                    )}
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default PatientFormModificationsHistoryRows
